var _rect, _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeatureIconwithcircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 97,
    viewBox: "0 0 96 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.75,
    width: 96,
    height: 96,
    rx: 48,
    fill: "#F4F5F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.6667 41V35.6667C62.6667 35.3131 62.5262 34.9739 62.2761 34.7239C62.0261 34.4738 61.687 34.3333 61.3333 34.3333H34.6667C34.313 34.3333 33.9739 34.4738 33.7239 34.7239C33.4738 34.9739 33.3333 35.3131 33.3333 35.6667V41H62.6667Z",
    fill: "#2EC5CE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 43.6667V62.3334C33.3333 62.687 33.4738 63.0261 33.7239 63.2762C33.9739 63.5262 34.313 63.6667 34.6667 63.6667H41.3333V43.6667H33.3333Z",
    fill: "#D6B1FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44 63.6667H61.3333C61.687 63.6667 62.0261 63.5262 62.2761 63.2762C62.5262 63.0261 62.6667 62.687 62.6667 62.3334V43.6667H44V63.6667Z",
    fill: "#8C30F5"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatureIconwithcircle);
export default __webpack_public_path__ + "static/media/Feature Icon with circle.d687dbd302626bcbf1c06887b15f6e55.svg";
export { ForwardRef as ReactComponent };